import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../UploadImageComponent";
import imgWarning from "../../assets/alert-warning.png";
export default function PopUpNotiLogin5req({ open, onClose, onSubmit }) {
  // state

  // useEffect

  return (
    <Modal show={open} onHide={onClose} size="sm" centered>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
          padding: 20,
          paddingBottom: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#343A40", fontSize: 20, fontWeight: 700 }}>
            ແຈ້ງເຕືອນ!
          </h1>
          <p style={{ color: "#6C757D", fontSize: 16 }}>
            ທ່ານໄດ້ເຂົ້າສູ່ລະບົບຜິດພາດເກີນ{" "}
            <span style={{ color: "#343A40", fontWeight: 700 }}>5 ຄັ້ງ,</span>{" "}
            ກະລຸນາກວດສອບດັ່ງຕໍ່ໄປນີ້:
          </p>
        </div>
        <div style={{ color: "#343A40", fontSize: 16, fontWeight: 700 }}>
          <div>1.) ທ່ານໄດ້ເຊື່ອມຕໍ່ອິນເຕີເນັດແລ້ວບໍ່?</div>
          <div>2.) ຖ້າບໍ່ຈື່ລະຫັດຜ່ານ ກະລຸນາສອບຖາມນຳຫົວໜ້າໜ່ວຍງານໃຫ້ກວດສອບ</div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={imgWarning} alt="" style={{ width: 100 }} />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 20, marginTop: 10 }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <Button
            variant="primary"
            size="md"
            style={{ minWidth: 120 }}
            onClick={onClose}
          >
            ຕົກລົງ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
